import React from "react";
import ConfirmationModal from "../../../../common/common_modal/confirmationModal/ConfirmationModal";
import "./TodaysCashCollectionModal.css";

const TodaysCashCollectionModal = ({
  show = true,
  onHide,
  onNoButtonClick,
  onYesButtonClick,
}) => {
  return (
    <ConfirmationModal
      show={show}
      onHide={onHide}
      title={"Today's Cash Collection"}
      statusTitle={"Have You Collected Today’s Cash?"}
      message={
        <>
          Please confirm you’ve{" "}
          <b>
            collected today’s store income & delivery boy’s
          </b>{" "}
          cash before going offline.

          <div className="hr_divider" />
        </>
      }
      noButtonText={"No, Collect Payment"}
      yesButtonText={"Yes, Collected"}
      onNoButtonClick={onNoButtonClick}
      onYesButtonClick={onYesButtonClick}
      className="TodaysCashCollectionModal"
    />
  );
};

export default TodaysCashCollectionModal;